import { render, staticRenderFns } from "./UploadedRules.vue?vue&type=template&id=f4254638&"
import script from "./UploadedRules.vue?vue&type=script&lang=js&"
export * from "./UploadedRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports